import ProductPanel from './ProductPanel';

// Makes ProductPanel the default import for this folder
export default ProductPanel;
